export default "__VITE_ASSET__B$LkfdwW__"